import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=2564f984&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=2564f984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564f984",
  null
  
)

export default component.exports